export const QUESTION_TYPE_MULTIPLE_CHOICE = 'multipleChoice';
export const QUESTION_TYPE_MULTIPLE_ANSWERS = 'multipleAnswers';
export const QUESTION_TYPE_DIVISION = 'division';
export const QUESTION_TYPE_SCALE = 'scale';
export const QUESTION_TYPE_SCALE_SMALL = 'scaleSmall';
export const QUESTION_TYPE_MESSAGE = 'message';

export const QUESTION_TYPE_FREETEXT_SMALL = 'freetextSmal';
export const QUESTION_TYPE_FREETEXT_LARGE = 'freetextLarge';
